import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';
import { expand } from 'uri-template-lite';
import { apiClient } from '../../common/ApiClient';
import { createApiQueryHook } from '../../common/queryClient/createApiQueryHook';
import { DataObjectDescriptionVersionUrl } from './DataObjectDescriptionVersionUrl';
import { DataObjectSchema } from '../schema';

const getDataObjectVersionEdit = (params: {
  id: number;
  lock?: boolean;
  clone?: boolean;
}) =>
  apiClient
    .get(expand(DataObjectDescriptionVersionUrl.edit, params))
    .then((response) => DataObjectSchema.parseFormData(response.data));

const queryKey = ['data-object-version'] as const;

export const useGetDataObjectVersionEditQuery = createApiQueryHook(
  queryKey,
  getDataObjectVersionEdit,
);

export const useRemoveDataObjectVersionEditQueries = () => {
  const queryClient = useQueryClient();
  return useCallback(
    () => queryClient.removeQueries({ queryKey, exact: false }),
    [queryClient],
  );
};
